<div class="host-deposit">
  <div class="text-center relative">
    <nz-radio-group [(ngModel)]="tabType" nzButtonStyle="solid"
                    (ngModelChange)="fetchDepositList()">
      <label nz-radio-button nzValue="paid">
        {{ "deposit.list.tab.paid" | translate }}
        <!-- 待退 -->
      </label>
      <label nz-radio-button nzValue="wait_pay">
        {{ "deposit.list.tab.wait_pay" | translate }}
        <!-- 待收 -->
      </label>
      <label nz-radio-button nzValue="refunded">
        {{ "deposit.list.tab.refunded" | translate }}
        <!-- 已退 -->
      </label>
    </nz-radio-group>
    <a
      class="absolute right-0 top-0"
      nz-button
      nzType="link"
      href="/app/metrics/monthly-financials?filter=deposit"
      target="_blank"
    >
      {{ "deposit.list.op.record" | translate }}
      <!-- 押金记录 -->
    </a>
  </div>
  <div class="py-[30px]">
    <nz-alert nzType="info"
              [nzMessage]="'deposit.list.alert.message' | translate" nzShowIcon
              nzCloseable></nz-alert>
  </div>
  <div class="table-wrapper">
    <nz-table class="v4-layout-list" [nzData]="listOfDeposit"
              [nzShowPagination]="false">
      <thead>
      <tr>
        <th style="width: 20%">
          {{ "deposit.list.table.th.guest" | translate }}
          <!-- 房客 -->
        </th>
        <th style="width: 20%">
          {{ "deposit.list.table.th.property" | translate }}
          <!-- 房间 -->
        </th>
        <th style="width: 14%">
          {{ "deposit.list.table.th.check" | translate }}
          <!-- 入离 -->
        </th>
        <th style="width: 20%">
          {{ "deposit.list.table.th.fee" | translate }}
          <!-- 房费 -->
        </th>
        <th style="width: 16%">
          {{ "deposit.list.table.th.deposit" | translate }}
          <!-- 押金 -->
        </th>
        <th style="width: 10%"></th>
      </tr>
      </thead>
      <tbody class="v4-layout-list-body">
      <tr *ngFor="let data of listOfDeposit">
        <td class="guest column">
          <div class="flex flex-row items-center">
            <img class="w-7 h-7 rounded-full" [src]="data.logos?.color"/>
            <div class="ml-3">
              <div class="guest-name">{{ data.client_name }}</div>
              <div
                class="guest-phone">{{ data.client_phone }} {{ data.number_of_adults }}</div>
            </div>
          </div>
        </td>
        <td class="house column">
          <div class="house-info">
            <span class="house-name">{{ data.house_title }}</span>
          </div>
        </td>
        <td class="checkin column">
          <div class="checkin-info">
            <div class="checkin-range">
              {{ data.check_in | dateformat : ["MD"] }}
              ~ {{ data.check_out | dateformat : ["MD"] }}
            </div>
            <div
              class="checkin-status"
              [class.wait-stay]="data?.status === 'wait_stay'"
              [class.staying]="data?.status === 'staying'"
              [class.completed]="data?.status === 'completed'"
              [class.wait-accept]="data?.status === 'wait_accept'"
              [class.wait-pay]="data?.status === 'wait_pay'"
            >
              {{ "order_status." + data.status | translate }}
            </div>
          </div>
        </td>
        <td class="fee column">
          <div class="fee-info">
            <div class="fee-total">
              <span>{{ data.currency_type | currencyToSymbol }}{{ data.house_fee }} </span>
              <span class="fee-clear"
                    *ngIf="[0, 2].indexOf(data?.settlement_status) !== -1"
              >({{ "order.money_cleared" | translate }})</span
              >
              <span class="fee-owe"
                    *ngIf="data?.settlement_status === 1">({{ "order.unpaid" | translate }}
                )</span>
            </div>
            <div class="fee-parts">
              <span
                class="commission">{{ "word.commission" | translate }} {{ data?.commission }} </span>
              <span
                class="net-fee">{{ "order.net_fee" | translate }} {{ data?.net_house_fee }}</span>
            </div>
          </div>
        </td>
        <td class="deposit column">
          <div class="deposit-info">
            <ng-container *ngIf="tabType === 'paid'">
              <div class="deposit-total">
                  <span>
                    <!-- 已收 {{ data.currency_type | currencyToSymbol }}{{ data.paid }} -->
                    {{
                    "deposit.list.table.td.paid"
                      | translate
                      : {
                        currency: data.deposit_currency | currencyToSymbol,
                        number: data.paid
                      }
                    }}
                  </span>
              </div>
              <div class="deposit-extra">
                  <span class="deposit-deducted" *ngIf="data.deducted">
                    {{
                    "deposit.list.table.td.deduct"
                      | translate
                      : {
                        number: (data.deposit_currency | currencyToSymbol) + data.deducted
                      }
                    }}
                    <!-- 扣除 {{ data.deducted }} -->
                  </span>
                <span>
                    {{
                  "deposit.list.table.td.pending_refund"
                    | translate
                    : {
                      number: (data.deposit_currency | currencyToSymbol) + data.pending_refund
                    }
                  }}
                  <!-- 待退 {{ data.pending_refund }} -->
                  </span>
              </div>
            </ng-container>

            <ng-container *ngIf="tabType === 'wait_pay'">
              <div class="deposit-total">
                {{
                "deposit.list.table.td.receivable"
                  | translate
                  : {
                    currency: data.deposit_currency | currencyToSymbol,
                    number: data.receivable
                  }
                }}
                <!-- 应收 {{ data.currency_type | currencyToSymbol }}{{ data.receivable }} -->
              </div>
            </ng-container>

            <ng-container *ngIf="tabType === 'refunded'">
              <div class="deposit-total">
                  <span>
                    {{
                    "deposit.list.table.td.paid"
                      | translate
                      : {
                        currency: data.deposit_currency | currencyToSymbol,
                        number: data.paid
                      }
                    }}
                    <!-- 已收 {{ data.currency_type | currencyToSymbol }}{{ data.paid }} -->
                  </span>
              </div>
              <div class="deposit-extra">
                  <span class="deposit-deducted" *ngIf="data.deducted">
                    {{
                    "deposit.list.table.td.deduct"
                      | translate
                      : {
                        number: (data.deposit_currency | currencyToSymbol) + data.deducted
                      }
                    }}
                    <!-- 扣除 {{ data.deducted }} -->
                  </span>
                <span>
                    {{
                  "deposit.list.table.td.refunded"
                    | translate
                    : {
                      number: (data.deposit_currency | currencyToSymbol) + data.refunded
                    }
                  }}
                  <!-- 已退 {{ data.refunded }} -->
                  </span>
              </div>
            </ng-container>
          </div>
        </td>
        <td class="operator column">
          <div class="column-wrap">
            <div class="operate"
                 *ngIf="tabType === 'paid' || (tabType === 'refunded' && data.show_button)">
              <button class="mb-[8px]" nz-button nzSize="small"
                      (click)="displayDeducteModal(deductedTpl, data)">
                {{ "deposit.list.table.op.deduct" | translate }}
                <!-- 扣押金 -->
              </button>
              <button nz-button nzSize="small"
                      (click)="displayRefundModal(data)">
                {{ "deposit.list.table.op.refund" | translate }}
                <!-- 退押金 -->
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </nz-table>
    <div class="text-right mt-4">
      <nz-pagination
        [nzHideOnSinglePage]="true"
        [(nzPageIndex)]="page"
        [nzPageSize]="pageSize"
        [nzTotal]="total"
        (nzPageIndexChange)="onPageChange()"
      ></nz-pagination>
    </div>
  </div>
</div>

<ng-template #deductedTpl>
  <div class="refund-container">
    <div class="tip">
      {{ "deposit.list.deduct.form_item.label" | translate }}
      <!-- 请输入准备扣除的金额 -->
    </div>
    <div class="control">
      <input type="number" nz-input
             [(ngModel)]="currentDeposit.waitDeductedDeposit"/>
    </div>
    <div class="info">
      <span class="s1">
        {{
        "deposit.list.deduct.form_item.paid"
          | translate
          : {
            number: (currentDeposit.deposit_currency | currencyToSymbol) + currentDeposit.paid
          }
        }}
        <!-- 已收 {{ currentDeposit.paid }} -->
      </span>
      <span class="s2">
        {{
        "deposit.list.table.td.pending_refund"
          | translate
          : {
            number:
              (currentDeposit.deposit_currency | currencyToSymbol) +
              (currentDeposit.paid - currentDeposit.waitDeductedDeposit | number : "1.0-3")
          }
        }}
        <!-- 待退 {{ currentDeposit.paid -
    currentDeposit.waitDeductedDeposit | number:
      '1.0-3' }} -->
      </span>
    </div>
  </div>
</ng-template>
